import { render, staticRenderFns } from "./PromoterList.vue?vue&type=template&id=2fb38087&scoped=true&"
import script from "./PromoterList.vue?vue&type=script&lang=js&"
export * from "./PromoterList.vue?vue&type=script&lang=js&"
import style0 from "./PromoterList.vue?vue&type=style&index=0&id=2fb38087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb38087",
  null
  
)

export default component.exports